import { canvasToFile, svgToCanvas } from '@aytm/app/stats/lib/render/svg-export'
// Intentionally no error handling — on network failure the Promise never resolves
// and the export hangs (legacy parity; the user can re-trigger).
export const toDataUrl = (image, url) =>
  new Promise(resolve => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.onload = () => {
      const reader = new FileReader()
      reader.onloadend = () => {
        image.baseSrc = reader.result
        resolve()
      }
      reader.readAsDataURL(xhr.response)
    }
    xhr.open('GET', url)
    xhr.send()
  })

export const formatSVG = ({ id, shelfData, shelfType, image }) => {
  if (!shelfData || shelfData.store === 'ecommerce') return

  const imageW = image.width
  const imageH = image.height

  const marginX = shelfType === 'displayFridge' ? 94 : 0
  let marginY = shelfType === 'displayFridge' ? 10 : shelfType === 'airCurtainFridge' ? 18 : 0
  if (shelfData.store === 'publix') marginY += 18

  const fullscreenScale = window[`AYTM_shelfScale_${shelfData.id}`] || 1
  if (fullscreenScale !== 1) {
    marginY = marginY - imageH * (1 - fullscreenScale) * 0.5
  }

  const SVG_NS = 'http://www.w3.org/2000/svg'
  const XLINK_NS = 'http://www.w3.org/1999/xlink'

  const svgParent = document.createElementNS(SVG_NS, 'svg')
  svgParent.setAttribute('version', '1.1')
  svgParent.setAttribute('xmlns:xlink', XLINK_NS)
  svgParent.setAttribute('xmlns', SVG_NS)
  svgParent.setAttribute('height', imageH)
  svgParent.setAttribute('width', imageW)
  svgParent.setAttribute('viewbox', `0 0 ${imageW} ${imageH}`)
  svgParent.style.opacity = '1'
  svgParent.style.zIndex = '1'

  const gNode = document.createElementNS(SVG_NS, 'g')
  gNode.style.transform = `scale(${1 / fullscreenScale})`

  let svgObject
  const svgHeatmapNode = document.querySelector(`#svg-heatmap${id}`)
  if (svgHeatmapNode) {
    svgObject = svgHeatmapNode.cloneNode(true)
    svgObject.style.zIndex = '100'
    svgObject.style.overflow = 'visible'
    svgObject.style.mixBlendMode = 'hard-light'
    svgObject.setAttribute('x', `${marginX}px`)
    svgObject.setAttribute('y', `${marginY}px`)
  }

  let imageNode
  if (image) {
    imageNode = document.createElementNS(SVG_NS, 'image')
    imageNode.setAttribute('style', 'position: absolute; top: 0; left: 0;')
    imageNode.setAttributeNS(XLINK_NS, 'xlink:href', image.baseSrc)
  }

  if (svgHeatmapNode) gNode.appendChild(svgObject)
  svgParent.appendChild(imageNode)
  svgParent.appendChild(gNode)

  const code = new XMLSerializer().serializeToString(svgParent)
  return `<?xml version="1.0" encoding="UTF-8" standalone="no"?>${code}`
}

export const downloadShelfAs = async ({ fileType, position, model }) => {
  const id = model.id
  const shelfData = model.shelf_preview_data
  if (!shelfData || shelfData.store === 'ecommerce') return

  const image = window[`AYTM_shelfImage_${shelfData.id}`]
  if (!image) return

  await toDataUrl(image, `https://${image.src}`)

  const svgData = formatSVG({ id, shelfData, shelfType: model.shelfType, image })
  const canvas = await svgToCanvas(svgData, image.width, image.height)

  return canvasToFile(canvas, fileType, position, 'export_heatmap')
}
